import { render, staticRenderFns } from "./swipers.vue?vue&type=template&id=8c19ca96&scoped=true&"
import script from "./swipers.vue?vue&type=script&lang=js&"
export * from "./swipers.vue?vue&type=script&lang=js&"
import style0 from "./swipers.vue?vue&type=style&index=0&id=8c19ca96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c19ca96",
  null
  
)

export default component.exports